import * as actions from '../../redux/actions';
import * as homeActions from '../../../home/redux/actions';

import { KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const initialState = {
	name: null,
	nameError: null,
	email: null,
	emailError: null,
	phoneNo: null,
	phoneNoError: null,
	comment: null,
	commentError: null,
};

const ThemeFourContactForm = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	return (
		<div className="themes-theme-four-contact-form new-container">
			{props.homeForm ? <HomeContactForm operator={operator} props={props} /> : null}

			{props.contactForm ? <ContactForm operator={operator} props={props} /> : null}
		</div>
	);
};

const HomeContactForm = ({ operator, props }) => {
	const [state, setState] = useState(initialState);
	const validate = () => {
		let errorCount = 0;

		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.phoneNo) {
			setState({
				...state,
				phoneNoError: true,
				phoneNoErrorMessage: 'Ingresa tu número de teléfono',
			});
			errorCount++;
		} else if (state.phoneNo && state.phoneNo.length !== 9) {
			setState({
				...state,
				phoneNoError: true,
				phoneNoErrorMessage: 'El número de teléfono debe tener 9 dígitos',
			});
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (state.email && !CommonService.isEMailValid(state.email)) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.comment) {
			setState({
				...state,
				commentError: true,
				commentErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};


	const onSubmit = () => {

		if (!validate()) {
			return;
		}
		let data = {
			name: state.name,
			email: state.email,
			phone_number: state.phoneNo,
			comments: state.comment,
			operator_id: props.home.operator.operator_id,
			operator_name: props.home.operator.operator_name,
		};
		props.actions
			.apiCall({
				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
			.then(
				res => onContactInfoResponse(res),
				err => onContactInfoResponse(err),
			);
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};

	const onChange = (value, type) => {
		if (type == 'phoneNo') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};
	const operatorName = operator && operator.operator_name;
	const getText = () => {
		if (operatorName === 'pullmandelsur') {
			return {
				light: 'Conoce junto a nosotros las ',
				bold: ' maravillas de la Región del Maule ',
				bg: operator.color_codes && operator.color_codes.button_color,
			};
		}
		if (operatorName === 'chilebus') {
			return {
				light: 'Conoce junto a nosotros las ',
				bold: ' maravillas del norte de Chile',
				bg: '#fe0000',
			};
		}
		if (operatorName === 'saopaulo') {
			return {
				light: 'Conoce junto a nosotros la ',
				bold: ' carretera Austral',
				bg: '#f7315c',
			};
		}
	};
	return (
		<div className="home-contact-container">
			<h2
				style={{
					color:
						operator &&
						operator.color_codes &&
						operator.color_codes.secondary_text_color &&
						operator.color_codes.secondary_text_color,
				}}
			>
				<span
					style={{
						background: getText() && getText().bg,
						display: 'inline-block',
					}}
				>
					<span
						style={{
							position: 'relative',
							top: '-8px',
						}}
					>
						{getText() && getText().light}
						<span className="bold-text">{getText() && getText().bold}</span>
					</span>
				</span>
			</h2>

			<div className="home-contact-form-section ">
				<h2
					className="bold-text"
					style={{
						color:
							operator &&
							operator.color_codes &&
							operator.color_codes.primary_text_color &&
							operator.color_codes.primary_text_color,
					}}
				>
					{/* {getIcons('titleLeftIcon') && (
            <img src={getIcons('titleLeftIcon')} alt="" className="title-icon" />
          )} */}
					Contáctanos{' '}
					{/* {getIcons('titleRightIcon') && (
            <img src={getIcons('titleRightIcon')} alt="" className="title-icon" />
          )} */}
				</h2>

				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Nombre</div>
					<KuposInput
						type="text"
						placeholder="Ej. Pedro"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.name}
						onChange={value => onChange(value, 'name')}
						error={!!state.nameError}
						errorMessage={state.nameErrorMessage}
					/>
				</div>

				<div className="contact-input-item ">
					<div className="contact-input-label less-bold-text ">Teléfono</div>
					<KuposInput
						type="text"
						placeholder="+56 9 0000 0000"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.phoneNo}
						onChange={value => onChange(value, 'phoneNo')}
						error={!!state.phoneNoError}
						errorMessage={state.phoneNoErrorMessage}
					/>
				</div>

				<div className="contact-input-item">

					{operator && operator.operator_name === "losnavegadores" ? (<div className="contact-input-label less-bold-text ">Correo electrónico</div>) : (<div className="contact-input-label less-bold-text ">Email</div>)}

					<KuposInput
						type="email"
						placeholder="ejemplo@gmail.com"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.email}
						onChange={value => onChange(value, 'email')}
						error={!!state.emailError}
						errorMessage={state.emailErrorMessage}
					/>
				</div>

				<div className="contact-input-item">
					{operator && operator.operator_name === "losnavegadores" ? (<div className="contact-input-label less-bold-text ">Mensaje</div>) : (<div className="contact-input-label less-bold-text ">Comentario</div>)}

					<KuposInput
						type="text"
						placeholder="Opcional"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.comment}
						onChange={value => onChange(value, 'comment')}
						error={!!state.commentError}
						errorMessage={state.commentErrorMessage}
					/>
				</div>

				<style>
					.btn{'{'}
					background:
					{operator &&
						operator.color_codes &&
						operator.color_codes.button_color &&
						operator.color_codes.button_color}
					{'}'}
					.btn:hover{'{'}
					background:
					{operator &&
						operator.color_codes &&
						operator.color_codes.tertiary_color &&
						operator.color_codes.tertiary_color}
					{'}'}
				</style>

				<div className="contact-input-item ">
					<button
						onClick={onSubmit}
						class="btn submit-btn  bold-text"
						style={{
							color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
						}}
					>
						ENVIAR
					</button>
				</div>
				<KuposErrorSuccessModal
					success={state.status == 200 ? true : false}
					showModal={state.showModal}
					onButtonClick={() => {
						setState({ showModal: false });
						// window.location.reload();
					}}
					bodyText={state.responseMessage}
				/>
			</div>
		</div>
	);
};

const getContactInfo = operator => {
	const saopauloContactInfo = [
		{
			image: getIcons('contactHeadphone', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
	];
	const santajuanaContactInfo = [
		{
			image: getIcons('contactHeadphone', operator),
			// caption: operator && operator.phone_number && operator.phone_number,
			caption:
				operator && operator.operator_name === 'santajuana'
					? '(+569) 99217771'
					: operator.phone_number,
			line: true,
		},
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
	];

	const pullmandelsurContactInfo = [
		{
			image: getIcons('contactHeadphone', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
	];

	const chilebusContactInfo = [
		{
			image: getIcons('contactHeadphone', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
	];
	const navegadoresContactInfo = [
		{
			image: getIcons('contactHeadphone', operator),
			caption: operator && operator.phone_number && operator.phone_number,
			line: true,
		},
		{
			image: getIcons('contactMail', operator),
			caption: operator && operator.email && operator.email,
			line: true,
		},
	];

	const name = operator && operator.operator_name;
	if (name === 'saopaulo') {
		return saopauloContactInfo;
	}
	if (name === 'santajuana') {
		return santajuanaContactInfo;
	}

	if (name === 'pullmandelsur') {
		return pullmandelsurContactInfo;
	}
	if (name === 'chilebus') {
		return chilebusContactInfo;
	}
	if (name === 'losnavegadores') {
		return navegadoresContactInfo;
	} else {
		return [];
	}
};

const ContactForm = ({ operator, props }) => {
	const [state, setState] = useState(initialState);
	const validate = () => {
		let errorCount = 0;

		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.phoneNo) {
			setState({
				...state,
				phoneNoError: true,
				phoneNoErrorMessage: 'Ingresa tu número de teléfono',
			});
			errorCount++;
		} else if (state.phoneNo && state.phoneNo.length !== 9) {
			setState({
				...state,
				phoneNoError: true,
				phoneNoErrorMessage: 'El número de teléfono debe tener 9 dígitos',
			});
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (state.email && !CommonService.isEMailValid(state.email)) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.comment) {
			setState({
				...state,
				commentError: true,
				commentErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};

	const onSubmit = () => {
		if (!validate()) {
			return;
		}
		let data = {
			name: state.name,
			email: state.email,
			phone_number: state.phoneNo,
			comments: state.comment,
			operator_id: props.home.operator.operator_id,
			operator_name: props.home.operator.operator_name,
		};
		props.actions
			.apiCall({
				url: AppData.BASE_URL + 'api/opsite_contact_info',
				method: 'POST',
				data,
			})
			.then(
				res => onContactInfoResponse(res),
				err => onContactInfoResponse(err),
			);
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};

	const onChange = (value, type) => {
		if (type == 'phoneNo') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};
	return (
		<div className="contact-container">
			<div className="contact-form-section">
				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Nombre</div>
					<KuposInput
						type="text"
						placeholder="Ej. Pedro"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.name}
						onChange={value => onChange(value, 'name')}
						error={!!state.nameError}
						errorMessage={state.nameErrorMessage}
					/>
				</div>

				<div className="contact-input-item ">
					<div className="contact-input-label less-bold-text ">Teléfono</div>
					<KuposInput
						type="text"
						placeholder="+56 9 0000 0000"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.phoneNo}
						onChange={value => onChange(value, 'phoneNo')}
						error={!!state.phoneNoError}
						errorMessage={state.phoneNoErrorMessage}
					/>
				</div>

				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Email</div>
					<KuposInput
						type="email"
						placeholder="ejemplo@gmail.com"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.email}
						onChange={value => onChange(value, 'email')}
						error={!!state.emailError}
						errorMessage={state.emailErrorMessage}
					/>
				</div>

				<div className="contact-input-item">
					<div className="contact-input-label less-bold-text ">Comentario</div>
					<KuposInput
						type="text"
						placeholder="Opcional"
						inputOuterStyle={{ border: '1px solid #cccc' }}
						className="kupos-border"
						value={state.comment}
						onChange={value => onChange(value, 'comment')}
						error={!!state.commentError}
						errorMessage={state.commentErrorMessage}
					/>
				</div>

				<style>
					.btn{'{'}
					background:
					{operator &&
						operator.color_codes &&
						operator.color_codes.button_color &&
						operator.color_codes.button_color}
					{'}'}
					.btn:hover{'{'}
					background:
					{operator &&
						operator.color_codes &&
						operator.color_codes.tertiary_color &&
						operator.color_codes.tertiary_color}
					{'}'}
				</style>

				<div className="contact-input-item ">
					<button
						onClick={onSubmit}
						class="btn submit-btn  bold-text"
						style={{
							color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
						}}
					>
						ENVIAR
					</button>
				</div>
				<KuposErrorSuccessModal
					success={state.status == 200 ? true : false}
					showModal={state.showModal}
					onButtonClick={() => {
						setState({ showModal: false });
						// window.location.reload();
					}}
					bodyText={state.responseMessage}
				/>
			</div>

			<ContactInfo operator={operator} />
		</div>
	);
};

const ContactInfo = ({ operator }) => {
	const operatorName = operator && operator.operator_name;

	const getLink = () => {
		if (operatorName === 'pullmandelsur') {
			return {
				fb: '',
				insta: 'https://www.instagram.com/pullmandelsur.cl/ ',
			};
		}

		if (operatorName === 'saopaulo') {
			return {
				fb: 'https://www.facebook.com/busessaopaulo',
				insta: 'https://www.instagram.com/buses.sao.paulo/',
			};
		}

		if (operatorName === 'santajuana') {
			return {
				contactFb: 'https://www.facebook.com/share/e2oWZgDus1RzB2Ea/?mibextid=qi2Omg',
				contactInsta: 'https://www.instagram.com/transportessantajuana/',
			};
		}

		if (operatorName === 'chilebus') {
			return {
				fb: 'https://www.facebook.com/chilebus/?locale=es_LA',
				insta: 'https://www.instagram.com/chilebus.cl/',
			};
		}
		if (operatorName === 'losnavegadores') {
			return {
				fb: 'https://www.facebook.com/buseslosnavegadores/',
				insta: 'https://www.instagram.com/los_navegadoressur/',
			};
		}
	};

	const renderIconsAndText = (item, key, length) => {
		return (
			<React.Fragment>
				<div className="item" key={key}>
					<div>
						<img src={item.image} alt="Giras de estudio" className="icon" />
					</div>
					<div className="caption">{item.caption}</div>
				</div>
				{item.line ? (
					<hr
						style={{
							borderColor: '#999999',
							// using hardcoded color here
							// borderColor: operator && operator.color_codes && operator.color_codes.primary_color,

							borderTopWidth: '2px',
						}}
					/>
				) : null}
			</React.Fragment>
		);
	};
	return (
		<div className="contact-us-info">
			{getContactInfo(operator).map((item, key) => {
				return renderIconsAndText(item, key);
			})}

			<div className="social-links">
				{operator && operator.operator_name === "losnavegadores" ? (<p className="caption less-bold-text font9">Síguenos en redes sociales</p>) : (<p className="less-bold-text">Síguenos en redes sociales</p>)}
				{getIcons('contactFb', operator) && (
					<a href={operator.operator_name === 'santajuana' ? getLink() && getLink().contactFb : getLink() && getLink().fb} target="_blank">
						<img src={getIcons('contactFb', operator)} alt="" className="social-icon fb" />
					</a>
				)}
				{/* {getIcons('contactFb', operator) && (
					<a href={operator.operator_name === 'chilebus' ? getLink().contactFb : getLink().insta} target="_blank">
						<img src={getIcons('contactFb', operator)} alt="" className="social-icon fb" />
					</a>
				)} */}
				{getIcons('contactInsta', operator) && (
					<a href={operator.operator_name === 'santajuana' ? getLink() && getLink().contactInsta : getLink() && getLink().insta} target="_blank">
						<img src={getIcons('contactInsta', operator)} alt="" className="social-icon insta" />
						{operator.operator_name === 'pullmandelsur' && (
							<span style={{ fontSize: '13px' }}>pullmandelsur.cl</span>
						)}
					</a>
				)}



				{/* {getIcons('contactInsta', operator) && (
          <a href={getLink().insta} target="_blank">
            <img src={getIcons('contactInsta', operator)} alt="" className="social-icon insta" />
            {operatorName === 'pullmandelsur' && (
              <span style={{ fontSize: '13px' }}>pullmandelsur.cl</span>
            )}
          </a>
        )} */}
			</div>
		</div>
	);
};

/* istanbul ignore next */
// function mapStateToProps(state) {
//   return {
//     themes: state.themes,
//     home: state.home,
//   };
// }

function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourContactForm);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourContactForm.js